import { Navigate, Route, generatePath } from "react-router-dom";
import React from "react";

export default function RedirectRoutes() {
  return (
    <>
      <Route
        path="/haul-pay/getpaid/history/:fundingRequestId"
        element={
          <Navigate
            to={generatePath("/haulpay/carrier/manage-pay/payment-details/:fundingRequestId", {
              fundingRequestId: window.location.pathname.split("/")[4] || ""
            })}
          />
        }
      />
      <Route path="/haul-pay/getpaid/request" element={<Navigate to="/haulpay/request-pay" />} />
      <Route
        path="/load/:loadId*"
        element={
          <Navigate
            to={generatePath("/loads/post/:loadId", {
              loadId: window.location.pathname.split("/")[2] || ""
            })}
          />
        }
      />
      <Route path="/settings/billing/subscription" element={<Navigate to="/settings/billing" />} />
      <Route
        path="/truck/:truckId*"
        element={
          <Navigate
            to={generatePath("/trucks/search/:truckId", {
              truckId: window.location.pathname.split("/")[2] || ""
            })}
          />
        }
      />
    </>
  );
}
